import { render } from "./cardConsumeReport.vue?vue&type=template&id=f396318c"
import script from "./cardConsumeReport.vue?vue&type=script&lang=js"
export * from "./cardConsumeReport.vue?vue&type=script&lang=js"

import "./cardConsumeReport.vue?vue&type=style&index=0&id=f396318c&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__